export default "__VITE_ASSET__QNETBe4$__"